module.exports = __webpack_public_path__ + "media/images/thumbs/biology/q_quiz_monocot_stem_3-4003dbb2471ce760c6c1bdbfa6fb2f6c.jpg";